import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom'; // Para manejar parámetros de la URL
import axios from 'axios';

function CheckStatus() {
    const [searchParams] = useSearchParams(); // Hook para acceder a los parámetros de la URL
    const [jobId, setJobId] = useState('');
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Recuperar el parámetro `jobId` de la URL al cargar el componente
    useEffect(() => {
        const initialJobId = searchParams.get('jobId'); // Obtener el parámetro `jobId` de la URL
        if (initialJobId) {
            setJobId(initialJobId); // Rellenar el estado con el parámetro
        }
    }, [searchParams]);

    const handleCheckStatus = async () => {
        if (!jobId.trim()) {
            setError('Por favor, introduce un ID de trabajo válido.');
            return;
        }

        setLoading(true);
        setStatus('');
        setError('');

        try {
            const response = await axios.get(
                `https://macc-apimanagement-cloudservices-pro.azure-api.net/alquizen-docs/api/documents/status/${jobId}`,
                {
                    timeout: 60000, // 1 minuto de espera
                }
            );

            const jobStatus = response.data;

            setStatus(jobStatus.status);

            if (jobStatus.status === 'failed') {
                setError(jobStatus.message || 'Ha ocurrido un error al procesar los documentos.');
            }
        } catch (error) {
            console.error('Error al verificar el estado:', error);
            if (error.code === 'ECONNABORTED') {
                setError('El proceso está tardando más de lo esperado. Por favor, inténtalo más tarde.');
            } else {
                setError('Error al verificar el estado. Por favor, verifica el ID de trabajo.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="check-status-container">
            <div className="form-group">
                <label htmlFor="jobId" className="form-label">
                    ID de Trabajo
                </label>
                <input
                    id="jobId"
                    type="text"
                    className="form-input check-status-input"
                    placeholder="Introduce el ID de trabajo"
                    value={jobId} // El valor del cuadro de texto se vincula al estado
                    onChange={(e) => setJobId(e.target.value)} // Actualizar el estado al cambiar el texto
                />
            </div>
            <button
                className={`button button-primary ${loading ? 'disabled' : ''}`}
                onClick={handleCheckStatus}
                disabled={loading || !jobId.trim()}
            >
                {loading ? (
                    <div className="spinner check-status-spinner" role="status"></div>
                ) : (
                    'Consultar Estado'
                )}
            </button>

            {status && (
                <div className="check-status-success alert alert-info">
                    <strong>Estado:</strong> {status}
                    {status === 'completed' && (
                        <div>
                            <a
                                href="https://maccresi.sharepoint.com/sites/DAssetMgmt/Private/Forms/AllItems.aspx?id=%2Fsites%2FDAssetMgmt%2FPrivate%2FAlquizen%2FDocumentacion&viewid=157d4bf9%2D85c5%2D4862%2D8263%2D0a5b5b0b9404"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-success mt-3"
                            >
                                Abrir Documentos en SharePoint
                            </a>
                        </div>
                    )}
                </div>
            )}

            {error && (
                <div className="check-status-error alert alert-danger">
                    <strong>Error:</strong> {error}
                </div>
            )}
        </div>
    );
}

export default CheckStatus;